


























































import { Component, Vue } from "vue-property-decorator";
import ShitiCompose from "@/components/shiti-compose.vue";

@Component({
  components: {
    ShitiCompose,
  },
})
export default class Name extends Vue {
  private type: any = ""; // 有值表示是校验痕迹详情，校验痕迹详情的接口不一样
  private source: any = ""; // 来源页面
  private kind: any = ""; // 知识库类型
  private id: any = "";
  private data: any = {};
  private ifShowSaveConfirm: any = false;

  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  private edit() {
    (this.$refs.shitiCompose as any).edit();
  }

  private save() {
    (this.$refs.shitiCompose as any).clickTijiao();
  }

  private clickModify(status: any) {
    (this.$refs.shitiCompose as any).clickModify(status);
  }
  private getData(data: any) {
    this.data = data;
    console.log('数据');
    console.log(this.data)
    this.$forceUpdate();
  }

  private back() {
    this.$store.commit("updateIfCompose", false);
    this.$router.back();
  }

  // /**
  //  * @description 离开页面前保存
  //  */
  // private beforeRouteLeave(to: any, from: any, next: any) {
  //   if (this.ifCompose) {
  //     this.ifShowSaveConfirm = true;
  //     next(false);
  //   } else {
  //     next(true);
  //   }
  // }

  private mounted() {
    if (this.$route.query.kind) {
      this.kind = this.$route.query.kind;
    }
    if (this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    // this.$store.commit("updateIfCompose", true);
  }
}
